import AlertMenu from "./alert-menu";

export default AlertMenu;
